import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import IngrdientIcon from "../../../assets/images/Icons/ingredient.svg";
import RecipeIcon from "../.../../../../assets/images/Icons/recipeIcon.svg";
import IngregrientDisabled from "../../../assets/images/Icons/ingredientDisabled.svg";
import RecipeDisabledIcon from "../../../assets/images/Icons/ic_recipe_disabled.svg";
import { formatWeightWithUnits } from "../../../utils";

export const IngredientsGroup = ({ ingredientGroup, globalData }) => {
  const isGroupDisabled = ingredientGroup.ingredients.every(
    (item) => !item.status
  );
  const navigate = useNavigate();

  const getTypeIcon = (type, status) => {
    switch (type) {
      case "ingredient":
        return status ? IngrdientIcon : IngregrientDisabled;
      case "recipe":
        return status ? RecipeIcon : RecipeDisabledIcon;
      default:
        <></>;
    }
  };

  const ingredientTag = (is_main_ingredient, is_batch_group, status) => {
    return (
      <>
        {is_main_ingredient || is_batch_group || !status ? (
          <Stack direction="row" gap="12px">
            <ul className="ingredient-list">
              {is_batch_group ? (
                <li>
                  <Typography
                    sx={{
                      color: status ? "#485364" : "#8E99AC",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "14.52px",
                    }}
                  >
                    Batch-Group
                  </Typography>
                </li>
              ) : null}
              {is_main_ingredient ? (
                <li>
                  <Typography
                    sx={{
                      color: status ? "#B42318" : "#8E99AC",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "14.52px",
                    }}
                  >
                    Main Ingredient
                  </Typography>
                </li>
              ) : null}{" "}
              {!status ? (
                <li>
                  <Typography
                    sx={{
                      color: "#0E7090",
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: "14.52px",
                    }}
                  >
                    Inactive
                  </Typography>
                </li>
              ) : null}
            </ul>
          </Stack>
        ) : null}
      </>
    );
  };

  return (
    <Stack
      sx={{
        backgroundColor: "#F7FAFC",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "12px",
          lineHeight: "14.52px",
          p: "10px 8px 10px 8px",
          height: "34px",
        }}
      >
        {ingredientGroup?.name}
      </Typography>

      <Box
        sx={{
          border: "1px solid #DFE8F2",
          borderRadius: "4px",
          boxShadow: "#000000",
        }}
      >
        {ingredientGroup.ingredients.map((ingredient) => {
          const destinationId =
            ingredient?.parent_ingredient_id || ingredient.ingredient_id;
          return (
            <Grid
              key={destinationId}
              container
              sx={{
                backgroundColor: "white",
                p: "8px",
                cursor: ingredient.status ? "pointer" : "",
                "&:hover": {
                  backgroundColor: ingredient.status ? "#0000001F" : "",
                },
                gap: "12px",
                borderBottom: "1px solid",
                borderColor: "divider",
              }}
              onClick={(e) => {
                navigate(
                  ingredient.type === "ingredient"
                    ? `/ingredients/details/${destinationId}`
                    : `/recipe/details/${destinationId}?basic-details`
                );
              }}
            >
              <Grid item m="auto" width="18px" height="18px">
                <Box
                  width="18px"
                  height="18px"
                  component="img"
                  src={getTypeIcon(ingredient.type, ingredient.status)}
                  alt="ingredient type icon"
                />
              </Grid>
              <Grid item flex={1}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    color: ingredient.status ? "#111C2B" : "#8E99AC",
                  }}
                >
                  {ingredient.name}
                </Typography>
                {ingredientTag(
                  ingredient.is_main_ingredient,
                  ingredient.is_batch_group,
                  ingredient.status
                )}
              </Grid>
              <Grid
                item
                xs={4}
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Typography
                  sx={{
                    float: "right",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "16.94px",
                    // color: "#1760D2",
                    color: ingredient.status ? "" : "#485364",
                  }}
                >
                  {formatWeightWithUnits(
                    ingredient.base_unit_qty,
                    ingredient.base_unit_symbol,
                    globalData?.all_Units
                  )}
                </Typography>
              </Grid>
            </Grid>
          );
        })}

        <Stack
          sx={{
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#E6EEF7",
            height: "34px",
            // p: "10px 8px 10px 8px",
            p: "10px 8px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              color: isGroupDisabled ? "#8E99AC" : "#111C2B",
            }}
          >
            Group Total
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              lineHeight: "14.52px",
              color: isGroupDisabled ? "#8E99AC" : "#111C2B",
            }}
          >
            {formatWeightWithUnits(
              ingredientGroup?.total_ingredient_qty,
              ingredientGroup?.total_qty_unit,
              globalData?.all_Units
            )}
          </Typography>
        </Stack>
        {ingredientGroup?.has_boiling_weight === 0 ? (
          ""
        ) : (
          <Stack
            sx={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              backgroundColor: "#D4E4FD",
              height: "34px",
              p: "10px 8px 10px 8px",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "12px",
                lineHeight: "14.52px",
                color: isGroupDisabled ? "#8E99AC" : "",
              }}
            >
              Group Boiled Weight
            </Typography>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "12px",
                lineHeight: "14.52px",
                color: isGroupDisabled ? "#8E99AC" : "",
              }}
            >
              {formatWeightWithUnits(
                ingredientGroup?.total_qty,
                ingredientGroup?.total_qty_unit,
                globalData?.all_Units
              )}
            </Typography>
          </Stack>
        )}
      </Box>
    </Stack>
  );
};
